import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeApiService } from '../../data/HomeApi.service';

declare var toastr: any;

@Component({
  selector: 'callback',
  templateUrl: './callback.component.html'
})


export class CallbackComponent {
  constructor(private route: ActivatedRoute,
    private homeApi: HomeApiService,
    private routes: Router) { }

  callbackKey: any;
  // Token: any;

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.callbackKey = params['token'];
        this.GetBodesToken(this.callbackKey);
      }
    );
  }

  GetBodesToken(callbackKey) {
    this.homeApi.GetTokenFromBodesApi(callbackKey).subscribe(
      data => {
        if (data != null)
          localStorage.setItem("token", data);
      },
      error => {
        console.log(error);
      },
      () => {
        this.routes.navigate(['dashboard'])
      }
    )
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/callback/callback.component.ts